module.exports = __webpack_public_path__ + "static/media/thumbup.2655e241.png";